import { type BeforeErrorState, isHTTPError } from '@enterprise/api';

import { customEvents } from '@/constants/custom-events';

/**
 * Handles HTTP 401 Unauthorized errors by dispatching a custom log off event.
 *
 * This function checks if the provided `HTTPError` contains a response with a status code of 401.
 * If so, it dispatches a custom event to notify the application that authentication is required.
 * The original error is then returned.
 *
 * @param error - The HTTPError object received from a failed HTTP request.
 * @returns The original HTTPError, or a Promise resolving to the HTTPError.
 */
export const authenticationRequired = ({ error }: BeforeErrorState): Error | Promise<Error> => {
  if (isHTTPError(error)) {
    const { response } = error;
    const { status } = response;

    if (status === 401) {
      dispatchEvent(new CustomEvent(customEvents.logOffEvent));
    }
  }

  return error;
};
